import React, { useEffect, useState } from "react";
import { BarLoader } from "react-spinners";
// shared
import { Title } from "shared/ui/title";
import { BaseInput } from "shared/ui/input";
import { Button } from "shared/ui/button";
// widgets
import { ModuleCreateFeature } from "features/module/module-create";
import { MusicWidget } from "widgets/music/ui";
// icons
import SearchIcon from "shared/icons/controls/search.svg";
import icon from "shared/icons/musicIcon.svg";
// effector
import { useStore } from "effector-react";
import { MGetMusic, MusicModel } from "entities/audio";
import { musicHandler } from "./lib/helpers";

const MusicPage = () => {
  const [visible, setVisible] = useState(false);
  const [music, setMusic] = useState<MGetMusic.Response["music"]>([]);
  const [searchText, setSearchText] = useState("");

  const handleAddButtonClick = () => {
    setVisible(!visible);
  };

  const musicData = useStore(MusicModel.$musicFx);
  const isLoading = useStore(MusicModel.getMusicFx.pending);

  useEffect(() => {
    const updateMusic = async () => {
      if (!isLoading && musicData !== null) {
        console.log("Raw musicData:", musicData);
        const newMusic = musicHandler(musicData);
        console.log("Processed music data:", newMusic);

        // Проверяем наличие свойства name в каждом элементе
        if (newMusic.length > 0) {
          console.log("Sample music item:", newMusic[0]);
          console.log(
            "Has 'name' property:",
            newMusic[0].hasOwnProperty("name"),
          );
          console.log("All properties:", Object.keys(newMusic[0]));
        }

        setMusic(newMusic);
      }
    };

    updateMusic();
  }, [isLoading, musicData]);

  useEffect(() => {
    MusicModel.getMusicFx();
  }, []);

  return (
    <>
      <div style={{ height: "calc(100vh - 70px)" }} className={"bg-[#F5F8FE]"}>
        <div className={"w-full px-4 py-4 h-[95%]"}>
          <Title className={"mb-6"} dark>
            Музыка
          </Title>
          <div
            className={
              "flex justify-between items-center mb-5 bg-[#EAF2FC] p-3 rounded-xl"
            }
          >
            <div className={"w-[38%]"}>
              <BaseInput
                placeholder={"Найти"}
                renderLeftIcon={SearchIcon}
                onInputChange={setSearchText}
              />
            </div>
            <div className={"flex"}>
              <div className={"w-[201px]"}>
                <Button onClick={handleAddButtonClick}>Добавить</Button>
              </div>
            </div>
          </div>

          {!isLoading ? (
            <MusicWidget music={music} searchText={searchText} />
          ) : (
            <div className="flex items-center justify-center w-full h-[74%]">
              <BarLoader color="#36D7B7" width={500} loading={isLoading} />
            </div>
          )}
        </div>
      </div>

      {visible && (
        <div className="overlay">
          <ModuleCreateFeature
            icon={icon}
            title="Выбрать файл"
            onChange={handleAddButtonClick}
            visible={visible}
            isImgInput={false}
            placeholderForInput="Добавить файл"
            type="file"
            categoryMusic="music"
            typeModule="addMusic"
          />
        </div>
      )}
    </>
  );
};

export { MusicPage };
